import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { useCallback } from 'react';
import styled from '@xstyled/styled-components';
import { Radio, Space } from 'antd';
import { BaseQuestionPreview } from './base-question-preview.component';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var AnswerItem = styled(Radio)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  span.ant-radio + * {\n    flex: 1;\n    height: auto;\n    padding-right: 0;\n  }\n  .ant-radio-inner::after {\n    background-color: ", ";\n  }\n  .ant-radio-checked .ant-radio-inner {\n    border-color: ", ";\n  }\n  .ant-input-affix-wrapper {\n    border-radius: 4px !important;\n    border-color: ", ";\n  }\n"])), styleVariables.colors.blue3, styleVariables.colors.blue3, styleVariables.colors.gray8);
var AnswerGroup = styled(Radio.Group)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
export var SingleChoiceQuestionPreview = function SingleChoiceQuestionPreview(props) {
  var question = props.question,
      index = props.index,
      previewMode = props.previewMode,
      onEditQuestion = props.onEditQuestion,
      sectionIndexSelected = props.sectionIndexSelected,
      onSubmitAnswer = props.onSubmitAnswer,
      defaultAnswer = props.defaultAnswer,
      submissionMode = props.submissionMode,
      disabled = props.disabled,
      active = props.active;
  var onFieldsChange = useCallback(function (e) {
    submissionMode && onSubmitAnswer(e.target.value);
  }, [onSubmitAnswer, submissionMode]);

  var SingleChoiceQuestionPreviewRender = function SingleChoiceQuestionPreviewRender(props) {
    var defaultValue = props.defaultValue;
    return /*#__PURE__*/_jsx(BaseQuestionPreview, {
      index: index,
      question: question,
      previewMode: previewMode,
      submissionMode: submissionMode,
      active: active,
      children: /*#__PURE__*/_jsx(AnswerGroup, {
        disabled: disabled,
        defaultValue: defaultValue || defaultAnswer,
        onChange: onFieldsChange,
        children: /*#__PURE__*/_jsx(Space, {
          direction: "vertical",
          children: question.answers.map(function (a, index) {
            return /*#__PURE__*/_jsx(AnswerItem, {
              value: a.id.toString(),
              disabled: isDisable,
              onChange: onChange,
              children: a.description
            }, index);
          })
        })
      })
    });
  };

  if (!(question !== null && question !== void 0 && question.correctAnswers)) {
    return /*#__PURE__*/_jsx(SingleChoiceQuestionPreviewRender, {});
  }

  var _question$correctAnsw = question === null || question === void 0 ? void 0 : question.correctAnswers,
      _question$correctAnsw2 = _slicedToArray(_question$correctAnsw, 1),
      correctAnswer = _question$correctAnsw2[0];

  var isDisable = !previewMode;

  var onChange = function onChange() {
    onEditQuestion(sectionIndexSelected, index);
  };

  return /*#__PURE__*/_jsx(SingleChoiceQuestionPreviewRender, {
    defaultValue: !previewMode && correctAnswer.answerId
  });
};